import { Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';

import EmptyIllustration from 'images/empty.png';

import * as S from './styles';

export const Empty: React.FC = () => {
  return (
    <S.Empty>
      <img src={EmptyIllustration} alt="" width={200} height={200} />
      <Typography>
        <FormattedMessage id="CPPLATFORM.CPINVITEMANAGEMENT.EMPTYSTATE" />
      </Typography>
    </S.Empty>
  );
};
